/*
 * Registr custom Vue aplikací.
 *
 * Každá aplikace má v Django šabloně svůj mount point, např.
 *   <div data-vue-app="kalendar"></div>
 *
 * Aplikace se načítá dynamickým importem, takže její kód (i CSS) je
 * samostatný chunk a nestahují ho stránky, kde mount point není.
 */
const APPS = {
  kalendar: () => import("./kalendar/main.js"),
};

/**
 * Přečte data-props. Rozbité JSON (typicky překlep v šabloně) nesmí shodit
 * mountování ostatních aplikací na stránce — proto se chyba jen zaloguje
 * a aplikace se namountuje s prázdnými props.
 */
function readProps(el) {
  if (!el.dataset.props) return {};

  try {
    return JSON.parse(el.dataset.props);
  } catch (err) {
    console.error(`Vue app "${el.dataset.vueApp}": nevalidní data-props`, err);
    return {};
  }
}

export function mountVueApps(root = document) {
  root.querySelectorAll("[data-vue-app]").forEach((el) => {
    const name = el.dataset.vueApp;
    const loader = APPS[name];

    if (!loader) {
      console.warn(`Unknown vue app "${name}"`);
      return;
    }

    loader()
      .then(({ default: mount }) => mount(el, readProps(el)))
      .catch((err) => {
        // Selhaný chunk (deploy během návštěvy, offline) nesmí zůstat
        // jako prázdné místo bez vysvětlení.
        console.error(`Vue app "${name}" se nepodařilo načíst`, err);
        el.setAttribute("data-vue-app-failed", "");
      });
  });
}
